import UIConstants from '../../../constants/UIConstants';
import stateCacheService from '../../../services/StateCache';
import flaggedItemsReader from '../../../store/readHelpers/FlaggedItemsReader';
import questionReader from '../../../store/readHelpers/QuestionReader';

const itemFlagButtonSelector = {
    selectShouldExcludeFlag(question, itemIdentifier, isHorizontal) {
        return !isHorizontal && questionReader.isInvertedMatchingResponseModel(question, itemIdentifier);
    },

    selectShouldHideFlag(orderNumber, isCurrentItem, isHorizontal, stimulusState) {
        return (!!orderNumber && !isCurrentItem) || (!!isHorizontal && stimulusState === UIConstants.STIMULUS_STATE.DRAG);
    },

    selectProps(state, ownProps) {
        const {
            question,
            orderNumber,
            itemIdentifier,
            isHorizontal,
            isCurrentItem,
        } = ownProps;

        const { ui: { stimulusState } } = state;

        const flagId = orderNumber ? `${question.contentRevisionId}-${orderNumber}` : `${question.contentRevisionId}`;

        return {
            stateCache: stateCacheService.getStateCacheInstance(),
            questionRevisionId: question.contentRevisionId,
            flagId,
            isFlagged: flaggedItemsReader.isItemFlagged(flagId),
            isFocused: flaggedItemsReader.isItemFocused(flagId),
            shouldExcludeFlag: this.selectShouldExcludeFlag(question, itemIdentifier, isHorizontal),
            shouldHideFlag: this.selectShouldHideFlag(orderNumber, isCurrentItem, isHorizontal, stimulusState),
        };
    },
};

export default itemFlagButtonSelector;
